<template>
    <div class="barcode-container" :class="$mq">
        <template v-if="step == 'qr'">
            <div class="qr-container">
                <div class="title">{{ $t('label.andyqr.title') }}</div>
                <template v-if="mode == false">
                    <div class="label">{{ $t('label.andyqr.manual_description') }}</div>
                    <div class="btns">
                        <div class="btn bc-read" @click="changeMode('auto')">{{ $t('label.andyqr.auto') }}</div>
                        <div class="btn bc-manual" @click="mode = 'manual'">{{ $t('label.andyqr.manual') }}</div>
                    </div>
                </template>
                <template v-if="mode == 'auto'">
                    <div class="scanner-windows">
                        <StreamBarcodeReader v-if="scan" @decode="onDecode"></StreamBarcodeReader>
                        <!-- <div class="button cancel" @click="mode = false"></div> -->
                    </div>
                    <div class="back" @click="mode = false">{{ $t('label.andyqr.back') }}</div>
                </template>
                <template v-if="mode == 'manual'">
                    <div class="manual">
                        <div class="label">{{ $t('label.andyqr.manual_description') }}</div>
                        <div class="input-container">
                            <input ref="inputText" type="text" v-bind:value="timestamp" class="input-ticketing" @focus="handleFocus" @blur="handleBlur" />
                        </div>
                        <div class="back" @click="mode = false">{{ $t('label.andyqr.back') }}</div>
                        <div class="next" @click="onDecode($refs.inputText.value)">{{ $t('label.andyqr.search') }}</div>
                    </div>
                </template>
            </div>
        </template>
        <template v-if="step == 'loading'">
            <div class="loading-container">
                <div class="title">{{ $t('label.andyqr.title') }}</div>
                <div class="loading-content">
                    <LottieAnimation style="width: 120px; height: 120px" :stopAnimation="stopAnimation" :animationName="'andy-simple-loader.json'"></LottieAnimation>
                    <span class="loading-text">{{ $t('label.andyqr.loading') }}</span>
                </div>
                <div class="back" @click="mode = false">{{ $t('label.andyqr.cancel') }}</div>
            </div>
        </template>
        <template v-if="step == 'error'">
            <div class="error-container">
                <div class="title">{{ $t('label.andyqr.title') }}</div>
                <div class="label">{{ $t('label.andyqr.manual_description') }}</div>
                <div class="error-box">
                    <div class="error-content"><i class="andy-icon i-andy-exclamation"></i> {{ error }}</div>
                    <div class="back" @click=";(mode = false), (error = false), (step = 'qr')">{{ $t('label.andyqr.retry') }}</div>
                </div>
            </div>
        </template>
        <template v-if="step == 'preview'">
            <div class="preview-container">
                <div class="title">{{ $t('label.andyqr.title_label_found') }}</div>
                <!-- <div class="label">{{ $t('label.andyqr.label_found_description') }}</div> -->
                <div v-if="error" class="error-content"><i class="andy-icon i-andy-exclamation"></i> {{ error }}</div>
                <div id="previous_labels" class="hide-scrollbar" :class="{ landscape: ['desktop', 'landscape'].includes($mq), 'no-results': previews.length == 0 && ['desktop', 'landscape'].includes($mq) }">
                    <template v-if="previews.length > 0">
                        <div class="preview_container hide-scrollbar" :class="{ selected: selectedLabel == index }" :key="index" v-for="(preview, index) in previews" @click="updateValue(index)">
                            <Preview v-if="!isAZplValid" :data="preview" :previousLabels="true" />
                            <ZplPreview v-else :data="zpl" :density="density" :width="labelWidth" :height="labelHeight" :values="zplValues" :params="zplParams" :showControls="false" :fitToContainer="true" :scale="1" :position="'center top'" />
                        </div>
                    </template>
                    <div class="btns">
                        <div
                            class="btn bc-read"
                            @click="
                                step = 'qr'
                                mode = false
                            "
                        >
                            {{ $t('label.andyqr.scanner_again') }}
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { StreamBarcodeReader } from 'vue-barcode-reader'
import VueQRCodeComponent from 'vue-qr-generator'
import VueBarcode from 'vue-barcode'
import Preview from '@/components/domain/label/preview.vue'
import i18n from '@/i18n'
import LottieAnimation from '@/components/layout/LottieAnimation.vue'
import ZplPreview from '@/components/domain/label/ZplPreview.vue'

export default {
    components: { StreamBarcodeReader, VueBarcode, VueQRCodeComponent, Preview, LottieAnimation, ZplPreview },
    props: {
        givenValue: { default: false },
        referenceId: { default: String }
    },
    data() {
        return {
            mode: false,
            timestamp: '',
            scan: false,
            step: 'qr',
            loading: true,
            counter: 0,
            value: '',
            labels: [],
            previews: [],
            error: false,
            selectedLabel: false,
            stopAnimation: false,
            isAZplValid: false,
            density: 203,
            labelWidth: 57,
            labelHeight: 51,
            zplValues: {},
            zplParams: {}
        }
    },
    computed: {
        isApp() {
            // return true
            return process.env.VUE_APP_IS_APP == 'TRUE'
        },

        currentCamera() {
            return this.$store.getters['getCurrentCamera']
        }
    },
    methods: {
        // GENERAL METHODS
        updateValue(index) {
            if (!this.error) {
                this.selectedLabel = index
                let data = this.labels[index]
                this.$emit('sendValue', data)
            }
        },

        load() {
            if (this.givenValue && this.givenValue !== '') {
                this.timestamp = this.givenValue
                // this.mode = 'manual'
            }
        },

        changeMode(mode) {
            if (mode == 'auto') {
                if (this.isApp) {
                    this.startBarcode()
                } else {
                    this.scan = true
                    this.mode = 'auto'
                }
            } else if (mode == 'manual') {
                this.mode = 'manual'
            }
        },

        // WINDOWS BARCODE AUTO SCANNER METHODS
        onDecode(barcode) {
            if (barcode == '' || barcode == ' ' || barcode == null) return
            this.value = barcode

            this.step = 'loading'

            let self = this
            self.error = false

            if (fnCheckConnection()) {
                this.$store.dispatch('label/loadPreviousLabels', { barcode: barcode }).then((response) => {
                    if (response.status) {
                        let data = response.data
                        if (data.length > 0) {
                            self.scan = false
                            self.mode = false
                            self.labels = data
                            data = data[0]
                            data.product = data.reference

                            if (!self.foundErrors(data)) {
                                self.step = 'preview'
                                data.current_print_time = data.date
                                let preview = self.previewLabel(data)
                                self.previews = [preview]
                                self.selectedLabel = 0
                                self.updateValue(self.selectedLabel)
                            } else {
                                self.step = 'error'
                            }
                        } else {
                            self.step = 'error'
                            self.error = i18n.t('label.previous_labels.no_results')
                        }
                    } else {
                        self.step = 'error'
                        self.error = i18n.t('label.previous_labels.no_results')
                    }
                })
            } else {
                this.step = 'error'
                this.error = i18n.t('label.andyqr.network_error')
            }
        },
        foundErrors(label) {
            if (label.reference != this.referenceId) {
                // this.step = 'error'
                this.error = i18n.t('label.andyqr.wrong_reference')
                return true
            }
            let data = JSON.parse(label.data)
            let caducidad = moment(data.caducidad, 'DD/MM/YYYY HH:mm')
            let prep_date = moment(data.prep_date, 'DD/MM/YYYY HH:mm')
            let date = moment(data.date, 'DD/MM/YYYY HH:mm')
            let current = moment()
            if (caducidad.isBefore(current)) {
                // this.step = 'error'
                this.error = i18n.t('label.andyqr.invalid_date')
                return true
            } else if (prep_date.isAfter(current)) {
                // this.step = 'error'
                this.error = i18n.t('label.andyqr.usodate_error')
                return true
            } else if (date.isBefore(current)) {
                // this.step = 'error'
                this.error = i18n.t('label.andyqr.invalid_date')
                return true
            }

            return false
        },
        previewLabel(label) {
            let reference = this.$store.getters['label/getLabel'](label.product)
            let printer = this.$store.getters['printer/getPrinter'] ? this.$store.getters['printer/getPrinter'] : this.$store.getters['login/getPrinter']
            let format = this.$store.getters['printer/getTemplates'](reference.states[label.state].format)
            let values = JSON.parse(format.data)
            if (label.preview) {
                try {
                    var params = JSON.parse(label.data)
                    let preview = JSON.parse(label.preview)

                    var oLocation = this.$store.getters['loginUser/getLocalLocation']
                    params['account'] = oLocation.account_name
                    params['location'] = oLocation.name
                    params['quantity'] = label.quantity
                    params['city'] = oLocation.city
                    params['address'] = oLocation.address
                    params['loc_state'] = oLocation.state
                    params['cp'] = oLocation.cp

                    for (let key in preview.fields) {
                        let field = preview.fields[key]
                        let value = typeof field.f_id !== 'undefined' ? values[field.f_id] : field.value
                        const regex = /[\{|\[][a-zA-Z0-9_\}|\]]*/gi
                        let m
                        let aux_value = value
                        while ((m = regex.exec(value)) !== null) {
                            // This is necessary to avoid infinite loops with zero-width matches
                            if (m.index === regex.lastIndex) {
                                regex.lastIndex++
                            }

                            // The result can be accessed through the `m`-variable.
                            m.forEach((match, groupIndex) => {
                                let m_index = match.replace(/[\{\}\[\]]/gi, '')
                                let name = this.$t('label.preview.' + m_index)

                                if (name.indexOf('label.preview.') != -1) {
                                    name = m_index
                                }

                                if (!Object.keys(params).includes(m_index)) {
                                    const regex2 = /(_d[0-9]|_day|_timestamp|_time)/gi
                                    let n
                                    while ((n = regex2.exec(m_index)) !== null) {
                                        // This is necessary to avoid infinite loops with zero-width matches
                                        if (n.m_index === regex2.lastIndex) {
                                            regex2.lastIndex++
                                        }

                                        // The result can be accessed through the `m`-variable.
                                        n.forEach((match2, groupIndex) => {
                                            let keyValue = m_index.replace(match2, '')
                                            if (Object.keys(params).includes(keyValue)) {
                                                let d = moment(params[keyValue], 'DD/MM/YYYY HH:mm')
                                                if (!d.isValid()) {
                                                    d = moment(parseInt(params[keyValue]) * 1000)
                                                }
                                                params[keyValue + '_day'] = d.format('DD/MM/YYYY')
                                                params[keyValue + '_time'] = d.format('HH:mm')
                                                params[keyValue + '_timestamp'] = parseInt(d.valueOf() / 1000).toString()
                                                params[keyValue + '_d1'] = d.isoWeekday() == 1 ? 'x' : ' '
                                                params[keyValue + '_d2'] = d.isoWeekday() == 2 ? 'x' : ' '
                                                params[keyValue + '_d3'] = d.isoWeekday() == 3 ? 'x' : ' '
                                                params[keyValue + '_d4'] = d.isoWeekday() == 4 ? 'x' : ' '
                                                params[keyValue + '_d5'] = d.isoWeekday() == 5 ? 'x' : ' '
                                                params[keyValue + '_d6'] = d.isoWeekday() == 6 ? 'x' : ' '
                                                params[keyValue + '_d7'] = d.isoWeekday() == 7 ? 'x' : ' '
                                            } else if (Object.keys(params).includes(keyValue + '_timestamp')) {
                                                let d = moment(parseInt(params[keyValue + '_timestamp']) * 1000)
                                                params[keyValue + '_day'] = d.format('DD/MM/YYYY')
                                                params[keyValue + '_time'] = d.format('HH:mm')
                                                params[keyValue] = d.format('DD/MM/YYYY HH:mm')
                                                params[keyValue + '_d1'] = d.isoWeekday() == 1 ? 'x' : ' '
                                                params[keyValue + '_d2'] = d.isoWeekday() == 2 ? 'x' : ' '
                                                params[keyValue + '_d3'] = d.isoWeekday() == 3 ? 'x' : ' '
                                                params[keyValue + '_d4'] = d.isoWeekday() == 4 ? 'x' : ' '
                                                params[keyValue + '_d5'] = d.isoWeekday() == 5 ? 'x' : ' '
                                                params[keyValue + '_d6'] = d.isoWeekday() == 6 ? 'x' : ' '
                                                params[keyValue + '_d7'] = d.isoWeekday() == 7 ? 'x' : ' '
                                            }
                                        })
                                    }

                                    if (!Object.keys(params).includes(m_index)) {
                                        params[m_index] = ''
                                    }
                                }

                                if (m_index != '' && Object.keys(params).includes(m_index)) {
                                    aux_value = aux_value.replace(match, params[m_index])
                                }
                            })
                        }
                        preview.fields[key].value = aux_value
                    }
                    this.$snackbar.close()
                    const { zpl, labelName } = this.extractZPLFromPrinter(format, printer)
                    if (zpl && this.isValidZPL(zpl)) {
                        let paramsInit = this.buildPreviewParams()

                        // Ajuste de print_date local si no la moviste manualmente
                        let date = moment()
                        if (!this.bUpdatedPrintDate) {
                            try {
                                const options = {
                                    timeZone: this.timezone,
                                    year: 'numeric',
                                    month: 'numeric',
                                    day: 'numeric',
                                    hour: 'numeric',
                                    minute: 'numeric',
                                    hour12: false
                                }
                                const copy = moment(date)
                                const dateTimeFormat = new Intl.DateTimeFormat([], options).formatToParts()
                                const objectDate = {}
                                for (const item of dateTimeFormat) objectDate[item.type] = item.value
                                const dateString = `${objectDate['day'].padStart(2, '0')}/${objectDate['month'].padStart(2, '0')}/${objectDate['year']} ${objectDate['hour'].padStart(2, '0')}:${objectDate['minute'].padStart(2, '0')}`
                                date = moment(dateString, 'DD/MM/YYYY HH:mm')
                                if (date.diff(copy, 'minutes') != serverTimeDifference) {
                                    const difference = serverTimeDifference - date.diff(copy, 'minutes')
                                    date = date.add(difference, 'minutes')
                                }
                            } catch (error) {
                                logError(error)
                            }
                        }

                        // Mantén consistente el this.print_date
                        this.print_date = this.bUpdatedPrintDate ? this.print_date : date

                        // Empuja el preview ZPL y termina
                        params = Object.assign({}, paramsInit, params)
                        this.openZplPreview({ zpl, format, labelName, params })
                        return false
                    } else {
                        return preview
                    }
                } catch (e) {
                    this.$snackbar.error({ message: i18n.t('label.preview.invalid'), closeable: true })
                }
            } else {
                this.$snackbar.error({ message: i18n.t('label.preview.invalid'), closeable: true })
            }
        },

        extractZPLFromPrinter(format, printer) {
            log('extractZPLFromPrinter', format, printer)
            try {
                if (!format || !printer) return null
                if (!printer.printers) return null
                if (!format.printer_id) return null

                var byId = printer.printers[format.printer_id]
                if (!byId) return null

                var labelsObj = byId.labels
                if (!labelsObj) return null

                var first = labelsObj[format.label_id] || null
                var zpl = first && first.data ? first.data : null
                var labelName = first && first.name ? first.name : null
                return { zpl, labelName }
            } catch (e) {
                return null
            }
        },

        openZplPreview({ zpl, format, labelName, params }) {
            // Parse seguro de format.data
            var values = {}
            try {
                values = JSON.parse(format && format.data ? format.data : '{}')
            } catch (e) {
                values = {}
            }

            var labelWidth = 55
            var labelHeight = 50

            // Lee realistic_preview si existe
            if (format && format.realistic_preview) {
                try {
                    var rp = JSON.parse(format.realistic_preview)
                    if (rp && typeof rp.width !== 'undefined') labelWidth = rp.width
                    if (rp && typeof rp.height !== 'undefined') labelHeight = rp.height
                } catch (e) {
                    console.log('error', e)
                }
            }

            this.zpl = zpl
            const dpi = checkDpi(labelName)
            const dimensions = getLabelDimensions(zpl, dpi)
            this.density = dpi
            this.labelWidth = dimensions.width
            this.labelHeight = dimensions.height
            this.zplValues = values
            this.zplParams = params
        },

        buildPreviewParams() {
            var product = this.label || {}
            var states = this.label && this.label.states ? this.label.states : {}
            var selState = this.processData && this.processData.selectedState && this.processData.selectedState.id != null ? this.processData.selectedState.id : null
            var stateCfg = selState != null ? states[selState] : null

            var stateName = stateCfg && stateCfg.name ? stateCfg.name : ''
            var timeMin = stateCfg && !isNaN(stateCfg.time) ? parseInt(stateCfg.time) : 0
            var prepMin = stateCfg && !isNaN(stateCfg.preptime) ? parseInt(stateCfg.preptime) : 0
            var isAnnotation = stateCfg && stateCfg.format === 'annotation'
            var msg = stateCfg && stateCfg.msg && stateCfg.msg.trim() !== '' ? stateCfg.msg : this.$t('label.preview.expired')

            var now = moment()
            var base = {
                title: stateName,
                date: isAnnotation ? msg : moment(now).add(timeMin, 'minutes').format('DD/MM/YYYY HH:mm'),
                product: product.name ? product.name : '',
                quantity: '1',
                print_date: now.format('DD/MM/YYYY HH:mm'),
                prep_date: moment(now).add(prepMin, 'minutes').format('DD/MM/YYYY HH:mm'),
                note: product.note ? product.note : '',
                note1: stateCfg && stateCfg.info && stateCfg.info.note1 ? stateCfg.info.note1 : '',
                note2: stateCfg && stateCfg.info && stateCfg.info.note2 ? stateCfg.info.note2 : '',
                note3: stateCfg && stateCfg.info && stateCfg.info.note3 ? stateCfg.info.note3 : '',
                state: stateCfg && stateCfg.state != null && this.optionsState && this.optionsState[stateCfg.state] ? this.optionsState[stateCfg.state].name : ''
            }

            var oLocation = this.$store.getters['loginUser/getLocalLocation'] || {}
            base['account'] = oLocation && oLocation.account_name ? oLocation.account_name : ''
            base['location'] = oLocation && oLocation.name ? oLocation.name : ''
            base['city'] = oLocation && oLocation.city ? oLocation.city : ''
            base['address'] = oLocation && oLocation.address ? oLocation.address : ''
            base['loc_state'] = oLocation && oLocation.state ? oLocation.state : ''
            base['cp'] = oLocation && oLocation.cp ? oLocation.cp : ''

            return base
        },

        isValidZPL(zpl) {
            this.isAZplValid = false

            if (typeof zpl !== 'string') return false

            const trimmed = zpl.trim()
            if (!trimmed.startsWith('^XA') || !trimmed.endsWith('^XZ')) {
                log('no es valido')
                return false
            }

            const hasCommands = /\^(FO|FD|FS|BY|BC|GB|AD)/.test(trimmed)

            this.isAZplValid = true
            return hasCommands
        },

        // APP BARCODE AUTO SCANNER METHODS
        startBarcode() {
            var self = this
            this.$store.commit('setBarcodeActive', true)
            QRScanner.prepare(
                function (err, status) {
                    if (err) {
                        // here we can handle errors and clean up any loose ends.
                        logError(err)
                    }
                    if (status.authorized) {
                        // W00t, you have camera access and the scanner is initialized.
                        // QRscanner.show() should feel very fast.
                    } else if (status.denied) {
                        // The video preview will remain black, and scanning is disabled. We can
                        // try to ask the user to change their mind, but we'll have to send them
                        // to their device settings with `QRScanner.openSettings()`.
                    } else {
                        // we didn't get permission, but we didn't get permanently denied. (On
                        // Android, a denial isn't permanent unless the user checks the "Don't
                        // ask again" box.) We can ask again at the next relevant opportunity.
                    }
                    // console.log('BARCODE READ')
                    if (self.$store.getters['printer/getFirstBackButton']) {
                        self.$store.commit('printer/setFirstBackButton', false)
                        document.addEventListener(
                            'backbutton',
                            function (e) {
                                self.destroyBarcode()
                            },
                            true
                        )
                    }
                    QRScanner.scan(self.displayContents, { formats: ['QR_CODE', 'CODE_39', 'CODE_128'] })
                    QRScanner.show(function (status) {
                        log(status)
                    })
                    QRScanner.useCamera(self.currentCamera ? self.currentCamera : 0, function (err, status) {
                        log(status)
                    })
                },
                { formats: ['QR_CODE', 'CODE_39', 'CODE_128'] }
            )
        },

        displayContents(err, barcode) {
            // console.log('DISPLAY CONTENTS')
            if (err) {
                logError(err)
            } else {
                if (this.loading) {
                    // Discart first readings
                    this.counter += 1
                    if (this.counter == 4) this.loading = false

                    var self = this
                    QRScanner.scan(self.displayContents, { formats: ['QR_CODE', 'CODE_39'] })
                } else {
                    // Start reading codes
                    if (this.value == barcode) {
                        this.counter += 1
                    } else {
                        this.value = barcode
                        this.counter = 1
                    }

                    if (this.counter < 7) {
                        var self = this
                        QRScanner.scan(self.displayContents, { formats: ['QR_CODE', 'CODE_39'] })
                    } else {
                        // The scan completed, display the contents of the QR code:
                        this.onDecode(barcode)
                        this.destroyBarcode()
                        // TODO - Remove confirmation page
                        this.preview = false
                    }
                }
            }
        },

        destroyBarcode() {
            this.loading = true
            this.counter = 0
            this.value = ''

            if (this.isApp && this.$store.getters.getBarcodeActive) {
                QRScanner.disableLight(function (err, status) {
                    log(status)
                })
                QRScanner.destroy(function (status) {})
            }
            this.$store.commit('setBarcodeActive', false)
            // TODO - Uncomment
        },

        // MANUAL BARCODE INPUT METHODS

        handleFocus(event, atElement) {
            let id = this.$refs.inputText
            atElement = typeof atElement === 'undefined' ? false : atElement

            this.$emit('handleFocus', true)
            this.$root.handleFocusKeyboard(this)
        },
        handleBlur(e) {
            this.$emit('handleFocus', false)
            this.$root.handleBlurKeyboard(this)

            // this.displayContents(false, e.target.value)
        }
    },
    mounted() {
        // if (!this.isApp) {
        //     this.mode = 'manual'
        // }
    },
    beforeDestroy() {
        this.destroyBarcode()
    },
    created() {},
    updated() {
        this.load()
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.barcode-container {
    @include display-flex();
    @include justify-content();
    width: 100%;
    text-align: center;
    margin-top: rem(18px);
    height: 100%;
    min-height: 50vh;

    .qr-container,
    .loading-container,
    .preview-container,
    .error-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
    }

    .loading-content {
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        justify-content: center;
        align-items: center;
        gap: 8px;
        padding-bottom: 12px;

        .loading-text {
            color: #374673;
            font-size: 22px;
            font-family: Avenir-Bold;
        }
    }

    .error-box {
        padding-top: 150px;
        @include background($image: img('illustrations/Andy05.svg'), $position: top 30px center, $size: 90px);
    }

    .error-content {
        display: flex;
        padding: 8px;
        justify-content: center;
        align-items: center;
        gap: 8px;
        margin-bottom: 48px;
        border-radius: 4px;
        border: 1px solid var(--error-dark-app, #bd1f1e);
        background: var(--error-t-90-app, #fcefef);

        .andy-icon {
            color: var(--error-dark-app, #bd1f1e);
        }
    }

    .title {
        color: $main;
        text-align: center;
        font-size: 22px;
        font-family: Avenir-Bold;
        line-height: 22px; /* 100% */
    }

    .btns {
        @include display-flex();
        @include flex-wrap(wrap);
        @include flex-direction(column);
        @include justify-content();

        .btn {
            font-family: $text-bold;
            margin: 15px auto;
            width: 100%;
            min-width: 300px;
            text-align: center;
            padding: 22px;
        }

        .bc-read {
            @include background($image: img('qr_light.svg'), $position: center left 20px, $size: 35px);
            padding-left: 55px;
        }

        .bc-manual {
            background-color: #dadeea;
            color: $main;
        }
    }

    .scanner {
        position: fixed;
        width: 100vw;
        height: 100vh;
        top: 0;
        left: 0;
        z-index: 9999999999999999999;

        .scan-box {
            background-color: grey;
            width: 500px;
            height: 500px;
            top: calc(50% - 250px);
            left: calc(50% - 250px);
            position: absolute;
        }

        .button {
            @include border-radius(6px);
            @include font-size('m');
            font-family: $text;
            position: absolute;
            min-width: 200px;
            min-height: 60px;
            bottom: 0px;
            padding: 20px 20px;
            margin: 30px;
            background-color: #fff;
            text-align: center;
            cursor: pointer;

            &.change {
                left: 0;
            }

            &.cancel {
                right: 0px;
            }
        }
    }

    .manual,
    #previous_labels {
        @include display-flex();
        @include justify-content();
        @include flex-direction(column);
        gap: 30px;

        .back,
        .next {
            max-width: 300px;
        }
    }

    .label {
        @include font-size('m');
        color: $neutro-s70;
        text-align: center;
        padding: 0 20px;
    }

    .preview {
        text-align: center;
        width: 100%;
        @include display-flex();
        @include justify-content();
        @include flex-direction(column);
        gap: 30px;

        .value {
            text-align: center;
            font-family: $text-bold;
            @include font-size('xl');
        }
        .barcode-show {
            text-align: center;
            @include border-radius(5px);
        }

        .qrcode {
            @include border-radius(5px);
            background: #fff;
            padding: 10px;
            align-self: center;
        }
    }

    .input-container {
        @include display-flex();
        @include justify-content();
        width: 100%;
        height: auto;

        .input-ticketing {
            @include font-size('l');
            @include border-radius($default-border-radius);
            @include background($image: img('input_text_cccccc.svg'), $color: #f6efee, $position: left 12px center, $size: 30px);
            width: 270px;
            height: 60px;
            left: 342px;
            top: 281px;
            border-bottom: none;
            padding: 1px 0;
            padding-left: 57px;
            // text-align: center;
        }
        .input-ticketing:hover {
            border-color: #f6efee;
        }
    }

    .back,
    .next {
        @include border-radius(6px);
        @include font-size('sm');
        font-family: $text-bold;
        color: $main;
        background-color: #dadeea;
        margin: 0 auto;
        // margin-top: 80px;
        text-align: center;
        width: 100%;
        text-transform: uppercase;
        padding: 20px 0;
        cursor: pointer;
    }

    .next {
        background-color: $main !important;
        color: $color-white;
    }
}
</style>

<style lang="scss">
$scanner-height: calc(61vh);
.scanner-windows {
    position: relative;
    height: $scanner-height;
    overflow: hidden;
    // width: 100%;
    max-width: 100%;
    min-width: 100px;
    min-height: 50vh;
    @include background($image: img('loader2_primary.svg'), $position: center center, $size: 100px);

    .scanner-container {
        width: 100%;
        height: $scanner-height;

        & > div {
            width: 100%;
            height: $scanner-height;

            & > video {
                width: 100%;
                height: $scanner-height;
            }

            & > .overlay-element {
                width: 100%;
                height: $scanner-height;
                -webkit-clip-path: polygon(0% 0%, 0% 100%, 10% 100%, 10% 35%, 90% 35%, 90% 60%, 10% 60%, 10% 100%, 100% 100%, 100% 0%) !important;
                clip-path: polygon(0% 0%, 0% 100%, 10% 100%, 10% 35%, 90% 35%, 90% 60%, 10% 60%, 10% 100%, 100% 100%, 100% 0%) !important;
            }
        }
    }

    .cancel {
        &.cancel {
            @include border-radius(100%);
            @include background($image: img('close_dark.svg'), $size: 20px, $position: center center);
            position: absolute;
            z-index: 99999;
            top: 10px;
            right: 10px;
            height: 50px;
            width: 50px;
            background-color: #fff;
            cursor: pointer;
        }
    }

    .back,
    .next {
        @include font-size('sm');
        // @include border-radius(0 0px 6px 0px);
        z-index: 99999;
        position: absolute;
        font-family: $text-bold;
        background-color: #dadeea;
        color: $main;
        margin: 0 auto;
        // top: 0;
        bottom: 0;
        left: 0;
        // margin-top: 80px;
        text-align: center;
        width: 100%;
        text-transform: uppercase;
        padding: 20px 0;
        cursor: pointer;
    }

    .next {
        background-color: $main;
        color: $color-white;
    }
}
</style>

// PORTRAIT STYLES
<style lang="scss" scoped>
#previous_labels {
    grid-template-columns: 1fr;
}
.barcode-container.portrait {
    margin-top: 0;
    height: calc(100%);
    .btns {
        width: 100%;
        .btn {
            @include font-size(s);
        }

        .bc-read {
        }

        .bc-manual {
            background-color: #dadeea;
        }
    }

    .scanner {
        .scan-box {
        }

        .button {
            &.change {
            }

            &.cancel {
            }
        }
    }

    .scanner-windows {
        .back {
            background-color: #dadeea;
        }
    }

    .manual {
        @include justify-content(space-evenly);
    }
    .label {
        @include font-size(s);
        margin-bottom: 0;
    }

    .input-container {
        .input-ticketing {
            width: 300px;
            background-color: #fff;
        }
        .input-ticketing:hover {
        }
    }

    .back,
    .next {
        margin-top: 0;
        background-color: #dadeea;
    }

    .preview {
        .value {
            @include font-size('l');
        }

        .barcode-show {
        }
    }
}
</style>
